// @ts-nocheck
(() => {
  const ROOT_SELECTOR = '.c-delivery-purchase-form';
  const NAMESPACE = 'deliveryPurchaseApplicationForm';
  const PICKUP_DATE_OPTION_DAYS = 5;
  const KIT_PICKUP_START_OFFSET_DAYS = 3;
  const NO_KIT_PICKUP_START_OFFSET_DAYS = 2;
  const KIT_VALUE_NO = '希望しない';
  const PICKUP_VALUE_NO = '集荷を希望しない';
  const DEFAULT_PICKUP_TIME_VALUE = '指定なし';
  const namespace = window[NAMESPACE] || {};

  function getJapanToday() {
    const parts = new Intl.DateTimeFormat('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).formatToParts(new Date());

    const dateParts = parts.reduce((result, part) => {
      if (part.type === 'year' || part.type === 'month' || part.type === 'day') {
        result[part.type] = Number(part.value);
      }

      return result;
    }, {});

    return new Date(dateParts.year, dateParts.month - 1, dateParts.day);
  }

  function addDays(date, days) {
    const nextDate = new Date(date.getTime());
    nextDate.setDate(nextDate.getDate() + days);
    return nextDate;
  }

  function formatJapaneseDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}年${month}月${day}日`;
  }

  function getCheckedValue(container) {
    const checkedInput = container ? container.querySelector('input[type="radio"]:checked') : null;
    return checkedInput ? checkedInput.value : '';
  }

  function setDisabled(element, disabled, clearValue) {
    if (!element) return;

    element.disabled = disabled;
    element.setAttribute('aria-disabled', disabled ? 'true' : 'false');

    if (disabled && clearValue) {
      element.value = '';
    }
  }

  function setRequired(element, required) {
    if (!element) return;

    element.required = required;

    if (required) {
      element.setAttribute('aria-required', 'true');
    } else {
      element.removeAttribute('aria-required');
    }
  }

  function setFieldState(element, settings) {
    if (!element) return;

    setDisabled(element, settings.disabled, settings.clearValue);
    setRequired(element, settings.required && !settings.disabled);

    if (settings.disabled) {
      clearFieldError(element);
    }
  }

  function sanitizePostalCode(postalCodeInput) {
    if (!postalCodeInput) return;

    let value = postalCodeInput.value.replace(/[^0-9-]/g, '');
    const hasHyphen = value.includes('-');

    if (hasHyphen) {
      const parts = value.split('-');
      value = `${parts.shift()}-${parts.join('')}`;
    }

    postalCodeInput.value = value.slice(0, 8);
  }

  function getErrorTarget(element) {
    if (!element) return null;

    const inputGroup = element.closest('.c-delivery-purchase-form__input-group');
    if (inputGroup) return inputGroup;

    const controlGroup = element.closest('.c-delivery-purchase-form__control-group');
    if (controlGroup) return controlGroup;

    return element;
  }

  function ensureErrorElement(element, errorId) {
    const target = getErrorTarget(element);
    if (!target) return null;

    let errorElement = document.getElementById(errorId);

    if (!errorElement) {
      errorElement = document.createElement('p');
      errorElement.id = errorId;
      errorElement.className = 'c-delivery-purchase-form__field-error';
      errorElement.hidden = true;
      errorElement.setAttribute('data-delivery-purchase-field-error', '');
      target.insertAdjacentElement('afterend', errorElement);
    }

    return errorElement;
  }

  function getFieldErrorId(element) {
    return `${element.id || element.name}-field-error`;
  }

  function appendDescribedBy(element, errorId) {
    const describedBy = element.getAttribute('aria-describedby') || '';

    if (!describedBy.split(' ').includes(errorId)) {
      element.setAttribute('aria-describedby', `${describedBy} ${errorId}`.trim());
    }
  }

  function removeDescribedBy(element, errorId) {
    const describedBy = element.getAttribute('aria-describedby') || '';
    const nextDescribedBy = describedBy
      .split(' ')
      .filter((id) => id && id !== errorId)
      .join(' ');

    if (nextDescribedBy) {
      element.setAttribute('aria-describedby', nextDescribedBy);
    } else {
      element.removeAttribute('aria-describedby');
    }
  }

  function showFieldError(element, message) {
    if (!element) return;

    const errorId = getFieldErrorId(element);
    const errorElement = ensureErrorElement(element, errorId);

    if (!errorElement) return;

    errorElement.textContent = message;
    errorElement.hidden = false;
    element.setAttribute('aria-invalid', 'true');
    appendDescribedBy(element, errorId);
  }

  function clearFieldError(element) {
    if (!element) return;

    const errorId = getFieldErrorId(element);
    const errorElement = document.getElementById(errorId);

    if (errorElement) {
      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    element.removeAttribute('aria-invalid');
    removeDescribedBy(element, errorId);
  }

  function showGroupError(group, message, errorId) {
    if (!group) return;

    let errorElement = document.getElementById(errorId);

    if (!errorElement) {
      errorElement = document.createElement('p');
      errorElement.id = errorId;
      errorElement.className = 'c-delivery-purchase-form__field-error';
      errorElement.hidden = true;
      errorElement.setAttribute('data-delivery-purchase-field-error', '');
      group.insertAdjacentElement('afterend', errorElement);
    }

    errorElement.textContent = message;
    errorElement.hidden = false;
    group.setAttribute('aria-invalid', 'true');
    group.querySelectorAll('input[type="radio"]').forEach((radioInput) => {
      radioInput.setAttribute('aria-invalid', 'true');
      appendDescribedBy(radioInput, errorId);
    });
  }

  function clearGroupError(group, errorId) {
    if (!group) return;

    const errorElement = document.getElementById(errorId);

    if (errorElement) {
      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    group.removeAttribute('aria-invalid');
    group.querySelectorAll('input[type="radio"]').forEach((radioInput) => {
      radioInput.removeAttribute('aria-invalid');
      removeDescribedBy(radioInput, errorId);
    });
  }

  function validateRequiredField(element, message) {
    if (!element || element.disabled || !element.required) return true;

    if (element.value.trim() === '') {
      showFieldError(element, message);
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function validateNumberField(element, requiredMessage, integerMessage, minMessage, minValue = 0) {
    if (!element || element.disabled || !element.required) return true;

    const rawValue = element.value.trim();

    if (rawValue === '') {
      showFieldError(element, requiredMessage);
      return false;
    }

    if (!/^[0-9]+$/.test(rawValue)) {
      showFieldError(element, integerMessage);
      return false;
    }

    const numberValue = Number(rawValue);

    if (numberValue < minValue) {
      showFieldError(element, minMessage);
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function getBoxCountLabel(element) {
    return element && element.name.includes('特大')
      ? 'ダンボール（特大）個数'
      : 'ダンボール（大）個数';
  }

  function validateBoxCountField(element) {
    const label = getBoxCountLabel(element);

    return validateNumberField(
      element,
      `${label}をご入力ください。`,
      `${label}は半角数字の整数で入力してください。`,
      `${label}は0以上で入力してください。`
    );
  }

  function getBoxCountGroupErrorId(formElement) {
    return formElement ? `${formElement.id}-box-count-group-field-error` : 'delivery-purchase-box-count-group-field-error';
  }

  function getBoxCountList(boxCountInputs) {
    const firstInput = boxCountInputs.find((boxCountInput) => boxCountInput);
    return firstInput ? firstInput.closest('.c-delivery-purchase-form__box-count-list') : null;
  }

  function showBoxCountGroupError(boxCountInputs, message, errorId) {
    const boxCountList = getBoxCountList(boxCountInputs);
    if (!boxCountList) return;

    let errorElement = document.getElementById(errorId);

    if (!errorElement) {
      errorElement = document.createElement('p');
      errorElement.id = errorId;
      errorElement.className = 'c-delivery-purchase-form__field-error';
      errorElement.hidden = true;
      errorElement.setAttribute('data-delivery-purchase-field-error', '');
    }

    const firstNotice = boxCountList.querySelector('.c-delivery-purchase-form__notice');
    boxCountList.insertBefore(errorElement, firstNotice);

    errorElement.textContent = message;
    errorElement.hidden = false;

    boxCountInputs.forEach((boxCountInput) => {
      if (!boxCountInput || boxCountInput.disabled) return;

      boxCountInput.setAttribute('aria-invalid', 'true');
      appendDescribedBy(boxCountInput, errorId);
    });
  }

  function clearBoxCountGroupError(boxCountInputs, errorId) {
    const errorElement = document.getElementById(errorId);

    if (errorElement) {
      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    boxCountInputs.forEach((boxCountInput) => {
      if (!boxCountInput) return;

      removeDescribedBy(boxCountInput, errorId);

      if (!boxCountInput.getAttribute('aria-describedby')) {
        boxCountInput.removeAttribute('aria-invalid');
      }
    });
  }

  function validateBoxCountGroup(boxCountInputs, errorId) {
    const activeBoxCountInputs = boxCountInputs.filter((boxCountInput) => (
      boxCountInput && !boxCountInput.disabled && boxCountInput.required
    ));

    if (activeBoxCountInputs.length === 0) {
      clearBoxCountGroupError(boxCountInputs, errorId);
      return true;
    }

    const hasIncompleteOrInvalidValue = activeBoxCountInputs.some((boxCountInput) => {
      const rawValue = boxCountInput.value.trim();

      if (rawValue === '') return true;
      if (!/^[0-9]+$/.test(rawValue)) return true;

      return Number(rawValue) < 0;
    });

    if (hasIncompleteOrInvalidValue) {
      clearBoxCountGroupError(boxCountInputs, errorId);
      return true;
    }

    const totalBoxCount = activeBoxCountInputs.reduce((total, boxCountInput) => (
      total + Number(boxCountInput.value.trim())
    ), 0);

    if (totalBoxCount <= 0) {
      showBoxCountGroupError(
        boxCountInputs,
        'ダンボール箱の個数はいずれか一方を1個以上で入力してください。',
        errorId
      );
      return false;
    }

    clearBoxCountGroupError(boxCountInputs, errorId);
    return true;
  }

  function validatePickupBoxCountField(element) {
    return validateNumberField(
      element,
      '引取希望の宅配用箱の個数をご入力ください。',
      '引取希望の宅配用箱の個数は半角数字の整数で入力してください。',
      '引取希望の宅配用箱の個数は1以上で入力してください。',
      1
    );
  }

  function validateSelectField(element, message) {
    if (!element || element.disabled || !element.required) return true;

    if (element.value === '') {
      showFieldError(element, message);
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function validateEmailField(element) {
    if (!element || element.disabled || !element.required) return true;

    if (element.value.trim() === '') {
      showFieldError(element, 'メールアドレスをご入力ください。');
      return false;
    }

    if (!element.checkValidity()) {
      showFieldError(element, 'メールアドレスの形式をご確認ください。');
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function validatePhoneField(element) {
    if (!element || element.disabled) return true;

    if (element.value.trim() !== '' && !/^[0-9-]+$/.test(element.value)) {
      showFieldError(element, '電話番号は半角数字とハイフンで入力してください。');
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function validatePostalCodeField(element) {
    if (!element || element.disabled || !element.required) return true;

    sanitizePostalCode(element);

    if (element.value.trim() === '') {
      showFieldError(element, '郵便番号をご入力ください。');
      return false;
    }

    if (!/^[0-9]{3}-?[0-9]{4}$/.test(element.value)) {
      showFieldError(element, '郵便番号は1234567または123-4567の形式で入力してください。');
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function validateRadioGroup(group, message, errorId) {
    if (getCheckedValue(group) === '') {
      showGroupError(group, message, errorId);
      return false;
    }

    clearGroupError(group, errorId);
    return true;
  }

  function renderPickupDateOptions(pickupDateSelect, startOffsetDays) {
    if (!pickupDateSelect) return;

    const selectedValue = pickupDateSelect.value;
    const dateValues = [];
    const fragment = document.createDocumentFragment();
    const placeholderOption = document.createElement('option');

    placeholderOption.value = '';
    placeholderOption.textContent = '選択してください';
    fragment.appendChild(placeholderOption);

    const japanToday = getJapanToday();

    for (let i = 0; i < PICKUP_DATE_OPTION_DAYS; i += 1) {
      const dateValue = formatJapaneseDate(addDays(japanToday, startOffsetDays + i));
      const option = document.createElement('option');

      option.value = dateValue;
      option.textContent = dateValue;
      dateValues.push(dateValue);
      fragment.appendChild(option);
    }

    pickupDateSelect.replaceChildren(fragment);
    pickupDateSelect.value = dateValues.includes(selectedValue) ? selectedValue : dateValues[0];
  }

  function initDeliveryPurchaseForm(root) {
    if (!root || root.dataset.deliveryPurchaseInitialized === 'true') return;

    const kitGroup = root.querySelector('[data-delivery-purchase-kit]');
    const boxCountInputs = Array.from(root.querySelectorAll('[data-delivery-purchase-box-count]'));
    const pickupGroup = root.querySelector('[data-delivery-purchase-pickup]');
    const pickupBoxCountInput = root.querySelector('[data-delivery-purchase-pickup-box-count]');
    const pickupDateSelect = root.querySelector('[data-delivery-purchase-pickup-date]');
    const pickupTimeSelect = root.querySelector('[data-delivery-purchase-pickup-time]');
    const postalCodeInput = root.querySelector('[data-delivery-purchase-postal-code]');
    const formElement = root.querySelector('form');
    const submitButton = root.querySelector('.c-delivery-purchase-form__button[type="submit"]');

    if (!kitGroup && !pickupGroup && !pickupDateSelect) return;

    root.dataset.deliveryPurchaseInitialized = 'true';

    if (formElement) {
      formElement.noValidate = true;
    }

    const lastNameInput = formElement ? formElement.elements['contact[お名前（姓）]'] : null;
    const firstNameInput = formElement ? formElement.elements['contact[お名前（名）]'] : null;
    const lastNameKanaInput = formElement ? formElement.elements['contact[フリガナ（セイ）]'] : null;
    const firstNameKanaInput = formElement ? formElement.elements['contact[フリガナ（メイ）]'] : null;
    const provinceSelect = formElement ? formElement.elements['contact[都道府県]'] : null;
    const cityInput = formElement ? formElement.elements['contact[市区町村]'] : null;
    const addressLineInput = formElement ? formElement.elements['contact[番地・建物名]'] : null;
    const phoneInput = formElement ? formElement.elements['contact[電話番号]'] : null;
    const emailInput = formElement ? formElement.elements['contact[email]'] : null;
    const kitErrorId = formElement ? `${formElement.id}-kit-field-error` : 'delivery-purchase-kit-field-error';
    const pickupErrorId = formElement ? `${formElement.id}-pickup-field-error` : 'delivery-purchase-pickup-field-error';
    const boxCountGroupErrorId = getBoxCountGroupErrorId(formElement);

    function getPickupStartOffsetDays() {
      return getCheckedValue(kitGroup) === KIT_VALUE_NO
        ? NO_KIT_PICKUP_START_OFFSET_DAYS
        : KIT_PICKUP_START_OFFSET_DAYS;
    }

    function updatePickupState() {
      const pickupDisabled = getCheckedValue(pickupGroup) === PICKUP_VALUE_NO;
      const pickupRequired = getCheckedValue(pickupGroup) === '希望する';

      if (!pickupDisabled && pickupDateSelect && pickupDateSelect.value === '') {
        renderPickupDateOptions(pickupDateSelect, getPickupStartOffsetDays());
      }

      setFieldState(pickupBoxCountInput, {
        disabled: pickupDisabled,
        required: pickupRequired,
        clearValue: true,
      });
      setFieldState(pickupDateSelect, {
        disabled: pickupDisabled,
        required: pickupRequired,
        clearValue: true,
      });

      if (pickupTimeSelect && pickupDisabled) {
        pickupTimeSelect.value = DEFAULT_PICKUP_TIME_VALUE;
      }

      setFieldState(pickupTimeSelect, {
        disabled: pickupDisabled,
        required: pickupRequired,
        clearValue: false,
      });
    }

    function updateKitState() {
      const boxCountDisabled = getCheckedValue(kitGroup) === KIT_VALUE_NO;
      const boxCountRequired = getCheckedValue(kitGroup) === '希望する';

      boxCountInputs.forEach((boxCountInput) => {
        setFieldState(boxCountInput, {
          disabled: boxCountDisabled,
          required: boxCountRequired,
          clearValue: true,
        });
      });

      if (boxCountDisabled) {
        clearBoxCountGroupError(boxCountInputs, boxCountGroupErrorId);
      }

      renderPickupDateOptions(pickupDateSelect, getPickupStartOffsetDays());
      updatePickupState();
    }

    function validateForm() {
      let firstInvalidElement = null;

      updateKitState();
      updatePickupState();

      function validateField(callback, focusElement) {
        const isValid = callback();

        if (!isValid && !firstInvalidElement) {
          firstInvalidElement = focusElement;
        }

        return isValid;
      }

      const isValid = [
        validateField(() => validateRequiredField(lastNameInput, 'お名前（姓）をご入力ください。'), lastNameInput),
        validateField(() => validateRequiredField(firstNameInput, 'お名前（名）をご入力ください。'), firstNameInput),
        validateField(() => validateRequiredField(lastNameKanaInput, 'フリガナ（セイ）をご入力ください。'), lastNameKanaInput),
        validateField(() => validateRequiredField(firstNameKanaInput, 'フリガナ（メイ）をご入力ください。'), firstNameKanaInput),
        validateField(() => validatePostalCodeField(postalCodeInput), postalCodeInput),
        validateField(() => validateSelectField(provinceSelect, '都道府県を選択してください。'), provinceSelect),
        validateField(() => validateRequiredField(cityInput, '市区町村をご入力ください。'), cityInput),
        validateField(() => validateRequiredField(addressLineInput, '番地・建物名をご入力ください。'), addressLineInput),
        validateField(() => validatePhoneField(phoneInput), phoneInput),
        validateField(() => validateEmailField(emailInput), emailInput),
        validateField(
          () => validateRadioGroup(kitGroup, '宅配キットを選択してください。', kitErrorId),
          kitGroup ? kitGroup.querySelector('input[type="radio"]') : null
        ),
        ...boxCountInputs.map((boxCountInput) => validateField(
          () => validateBoxCountField(boxCountInput),
          boxCountInput
        )),
        validateField(
          () => validateBoxCountGroup(boxCountInputs, boxCountGroupErrorId),
          boxCountInputs.find((boxCountInput) => boxCountInput && !boxCountInput.disabled) || null
        ),
        validateField(
          () => validateRadioGroup(pickupGroup, '配送業者による集荷を選択してください。', pickupErrorId),
          pickupGroup ? pickupGroup.querySelector('input[type="radio"]') : null
        ),
        validateField(
          () => validatePickupBoxCountField(pickupBoxCountInput),
          pickupBoxCountInput
        ),
        validateField(() => validateSelectField(pickupDateSelect, '集荷希望日を選択してください。'), pickupDateSelect),
        validateField(() => validateSelectField(pickupTimeSelect, '集荷希望時間帯を選択してください。'), pickupTimeSelect),
      ].every(Boolean);

      if (!isValid && firstInvalidElement) {
        firstInvalidElement.focus();
      }

      return isValid;
    }

    function validateFieldIfInvalid(element, callback) {
      if (!element) return;

      if (element.getAttribute('aria-invalid') === 'true') {
        callback();
      }
    }

    function stopInvalidSubmit(event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      return false;
    }

    function handleFormSubmit(event) {
      if (!validateForm()) {
        return stopInvalidSubmit(event);
      }

      return true;
    }

    [
      [lastNameInput, () => validateRequiredField(lastNameInput, 'お名前（姓）をご入力ください。')],
      [firstNameInput, () => validateRequiredField(firstNameInput, 'お名前（名）をご入力ください。')],
      [lastNameKanaInput, () => validateRequiredField(lastNameKanaInput, 'フリガナ（セイ）をご入力ください。')],
      [firstNameKanaInput, () => validateRequiredField(firstNameKanaInput, 'フリガナ（メイ）をご入力ください。')],
      [cityInput, () => validateRequiredField(cityInput, '市区町村をご入力ください。')],
      [addressLineInput, () => validateRequiredField(addressLineInput, '番地・建物名をご入力ください。')],
      [phoneInput, () => validatePhoneField(phoneInput)],
      [emailInput, () => validateEmailField(emailInput)],
      [pickupBoxCountInput, () => validatePickupBoxCountField(pickupBoxCountInput)],
    ].forEach((entry) => {
      const element = entry[0];
      const callback = entry[1];

      if (!element) return;

      element.addEventListener('input', () => {
        validateFieldIfInvalid(element, callback);
      });
    });

    boxCountInputs.forEach((boxCountInput) => {
      boxCountInput.addEventListener('input', () => {
        validateFieldIfInvalid(boxCountInput, () => validateBoxCountField(boxCountInput));

        if (document.getElementById(boxCountGroupErrorId)) {
          validateBoxCountGroup(boxCountInputs, boxCountGroupErrorId);
        }
      });
    });

    if (provinceSelect) {
      provinceSelect.addEventListener('change', () => {
        validateFieldIfInvalid(provinceSelect, () => validateSelectField(provinceSelect, '都道府県を選択してください。'));
      });
    }

    if (pickupDateSelect) {
      pickupDateSelect.addEventListener('change', () => {
        validateFieldIfInvalid(pickupDateSelect, () => validateSelectField(pickupDateSelect, '集荷希望日を選択してください。'));
      });
    }

    if (pickupTimeSelect) {
      pickupTimeSelect.addEventListener('change', () => {
        validateFieldIfInvalid(pickupTimeSelect, () => validateSelectField(pickupTimeSelect, '集荷希望時間帯を選択してください。'));
      });
    }

    if (kitGroup) {
      kitGroup.addEventListener('change', () => {
        updateKitState();
        clearGroupError(kitGroup, kitErrorId);
        boxCountInputs.forEach((boxCountInput) => {
          validateFieldIfInvalid(boxCountInput, () => validateBoxCountField(boxCountInput));
        });
        clearBoxCountGroupError(boxCountInputs, boxCountGroupErrorId);
      });
    }

    if (pickupGroup) {
      pickupGroup.addEventListener('change', () => {
        updatePickupState();
        clearGroupError(pickupGroup, pickupErrorId);
        validateFieldIfInvalid(pickupBoxCountInput, () => validatePickupBoxCountField(pickupBoxCountInput));
        validateFieldIfInvalid(pickupDateSelect, () => validateSelectField(pickupDateSelect, '集荷希望日を選択してください。'));
        validateFieldIfInvalid(pickupTimeSelect, () => validateSelectField(pickupTimeSelect, '集荷希望時間帯を選択してください。'));
      });
    }

    if (postalCodeInput) {
      postalCodeInput.addEventListener('input', () => {
        sanitizePostalCode(postalCodeInput);
        validateFieldIfInvalid(postalCodeInput, validatePostalCodeField.bind(null, postalCodeInput));
      });
      sanitizePostalCode(postalCodeInput);
    }

    if (formElement) {
      formElement.addEventListener('submit', handleFormSubmit, true);
    }

    if (submitButton) {
      submitButton.addEventListener('click', (event) => {
        if (!validateForm()) {
          return stopInvalidSubmit(event);
        }

        return true;
      }, true);
    }

    renderPickupDateOptions(pickupDateSelect, getPickupStartOffsetDays());
    updateKitState();
    updatePickupState();
  }

  function initAll(scope) {
    const targetScope = scope || document;
    targetScope.querySelectorAll(ROOT_SELECTOR).forEach(initDeliveryPurchaseForm);
  }

  window[NAMESPACE] = Object.assign(namespace, {
    initAll,
    listenersRegistered: namespace.listenersRegistered === true,
  });

  if (!window[NAMESPACE].listenersRegistered) {
    document.addEventListener('DOMContentLoaded', () => {
      window[NAMESPACE].initAll(document);
    });

    document.addEventListener('shopify:section:load', (event) => {
      window[NAMESPACE].initAll(event.target);
    });

    window[NAMESPACE].listenersRegistered = true;
  }

  window[NAMESPACE].initAll(document);
})();
